export const GroupNavLabel = 'Select a Health Plan for'
export enum AccordionToggle {
  Open = 'opened',
  Close = 'closed',
}
export const MODULE = 'ShopForHealth'
export const UNKNOWN = 'Unknown'
